import Home from "./Components/Home";
import Navbar from "./Components/Navbar";
import SocialLink from "./Components/SocialLink";
import About from "./Components/About";
import Portfolio from "./Components/Portfolio";
import Experience from "./Components/Experience";
import Contact from "./Components/Contact";


function App() {
  return (
 <>
 <Navbar />
 <Home /> 
 <SocialLink />
 <About />
 < Portfolio />
 <Experience />
 <Contact/> 
 </>
  );
}

export default App;
